export default (changesByExerciseID) => {
  const defaultJustifications = {}

  Object.keys(changesByExerciseID).forEach((exerciseId) => {
    defaultJustifications[exerciseId] = ({ explanation: '', portal_based: true, reason: 'automatic' })
  })

  return defaultJustifications
}
